import { next } from '@ember/runloop';
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface IBvSplitPaneResizerArgs {
  registerWithParent: (element: HTMLElement) => void;
}

export default class BvSplitPaneResizer extends Component<IBvSplitPaneResizerArgs> {
  @action
  handleDidInsert(element: HTMLElement) {
    // run next to avoid changing the component during a render iteration
    next(this, () => {
      this.args.registerWithParent?.(element);
    });
  }
}
